import { getDataFromLocalStorage, localStorageData, sessionStorageData } from "../services/localStorage";
import { socket } from "../api/api";
import { useEffect } from "react";
import { SOCKET_EVENTS } from "../common/socket";

export function getTabId() {
  const stored = sessionStorage.getItem(sessionStorageData.tabId);
  if (stored) return stored;
  const newId = window.crypto?.randomUUID?.() ||
    `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  sessionStorage.setItem(sessionStorageData.tabId, newId);
  return newId;
}

export function useSocketRegistration(user) {
  const userId = user?.id;
  
  useEffect(() => {
    if (!socket || !userId) return;
    const { deviceId, username } = user;
    if (!userId || !deviceId) return;

    const register = () => {
      if (socket.connected) {
        socket.emit(SOCKET_EVENTS.register, {
          auth: { userId, deviceId, tabId: getTabId(), username }
        });
      }
    };
    if (socket.connected) {
      register();
    }

    socket.on(SOCKET_EVENTS.connect, register);

    return () => {
      socket.off(SOCKET_EVENTS.connect, register);
      // сообщить серверу, что вкладка закрывается
      // socket.emit(SOCKET_EVENTS.unregister, { userId, deviceId, tabId });
    };
  }, [socket, userId]);
}